module.exports = "/_next/static/images/megaphone-765960c5506d38b2d09cd3f4d94efc50.png";